import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';

const TaskModal = ({ show, onHide, mode, taskId, refreshTasks, roleName }) => {
  const [formData, setFormData] = useState({
    AdditionalComments: '',
    selectedFiles: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Load task data for editing
  useEffect(() => {
    if (show && mode === 'edit' && taskId) {
      const loadTask = async () => {
        setIsLoading(true);
        try {
          const response = await fetch(`/api/tasks/${taskId}`);
          const task = await response.json();
          setFormData({
            AdditionalComments: task.AdditionalComments || '',
            selectedFiles: task.selectedFiles || [], // Assuming task has an array of files
          });
        } catch (error) {
          console.error('Error loading task:', error);
        } finally {
          setIsLoading(false);
        }
      };
      loadTask();
    }
  }, [show, mode, taskId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const url = mode === 'edit' 
        ? `/api/tasks/${taskId}`
        : '/api/tasks';
      
      const method = mode === 'edit' ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
        })
      });

      if (response.ok) {
        refreshTasks();
        onHide();
      }
    } catch (error) {
      console.error('Error saving task:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.AdditionalComments.trim()) {
      newErrors.AdditionalComments = 'Additional Comments are required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="modal-customheader">
        <Modal.Title className="custom-modaltitle">{mode === 'edit' ? 'Edit Task' : 'Create Task'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="custommodal-body">
        <Form onSubmit={handleSubmit}>
          {/* Only show Additional Comments and Attachments if OfficerResponsible */
          }
          {roleName === 'OfficerResponsible' && (
            <>
              {/* Additional Comments Field */}
              <Form.Group as={Row} controlId="additionalComments">
                <Form.Label column sm={3}>Additional Comments</Form.Label>
                <Col sm={9}>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={formData.AdditionalComments}
                    onChange={(e) => setFormData({ ...formData, AdditionalComments: e.target.value })}
                  />
                  {errors.AdditionalComments && <div className="text-danger">{errors.AdditionalComments}</div>}
                </Col>
              </Form.Group>

              {/* Attachments Field */}
              <Form.Group as={Row} controlId="attachments">
                <Form.Label column sm={3}>Attachments</Form.Label>
                <Col sm={9}>
                  <Form.Control
                    type="file"
                    multiple
                    onChange={(e) => setFormData({ ...formData, selectedFiles: e.target.files })}
                  />
                </Col>
              </Form.Group>
            </>
          )}

          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? <Spinner animation="border" size="sm" /> : 'Save Task'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default TaskModal;
